import { toast } from "react-toastify";
import { IDefaultRouteCostsData } from "../types";

interface ValidationErrors {
  transshipPointId?: boolean;
  costs: Array<{
    vehicleTypeId?: boolean;
    initialCapacity?: boolean;
    finalCapacity?: boolean;
    overlapError?: boolean;
    cost?: boolean;
    leaderCommission?: boolean;
    additionalDelivery?: boolean;
  }>;
}

export const validateForm = (form: IDefaultRouteCostsData): { isValid: boolean; errors: ValidationErrors } => {
  let isValid = true;
  const newErrors: ValidationErrors = {
    costs: form.costs.map(() => ({
      vehicleTypeId: false,
      initialCapacity: false,
      finalCapacity: false,
      overlapError: false,
      cost: false,
      leaderCommission: false,
      additionalDelivery: false
    }))
  };

  const errorMessages = new Set<string>();

  // Verificar se o centro de distribuição foi selecionado
  if (!form.transshipPointId) {
    newErrors.transshipPointId = true;
    isValid = false;
    errorMessages.add("Selecione um Centro de Distribuição");
  }

  // Verificar tipos de veículo duplicados
  const vehicleTypesCount = new Map<number, number>();
  const vehicleTypeIndices = new Map<number, number[]>();
  
  form.costs.forEach((item, index) => {
    vehicleTypesCount.set(item.vehicleTypeId, (vehicleTypesCount.get(item.vehicleTypeId) || 0) + 1);
    
    if (!vehicleTypeIndices.has(item.vehicleTypeId)) {
      vehicleTypeIndices.set(item.vehicleTypeId, []);
    }
    vehicleTypeIndices.get(item.vehicleTypeId)?.push(index);
  });

  let hasDuplicates = false;
  vehicleTypesCount.forEach((count, typeId) => {
    if (count > 1) {
      vehicleTypeIndices.get(typeId)?.forEach(index => {
        newErrors.costs[index].vehicleTypeId = true;
      });
      hasDuplicates = true;
      isValid = false;
    }
  });

  if (hasDuplicates) {
    errorMessages.add("Existem tipos de veículo duplicados. Cada tipo deve aparecer apenas uma vez.");
  }

  // Verificar capacidades iniciais e finais
  let hasCapacityError = false;
  form.costs.forEach((item, index) => {
    if (item.initialCapacity >= item.finalCapacity) {
      newErrors.costs[index].initialCapacity = true;
      newErrors.costs[index].finalCapacity = true;
      hasCapacityError = true;
      isValid = false;
    }
  });

  if (hasCapacityError) {
    errorMessages.add("A capacidade inicial deve ser menor que a capacidade final");
  }

  // Verificar sobreposição de intervalos de capacidade (qualquer tipo)
  let hasOverlap = false;
  form.costs.forEach((item, index) => {
    const overlaps = form.costs.some((otherItem, otherIndex) => {
      if (index === otherIndex) return false;
      
      return (
        (item.initialCapacity >= otherItem.initialCapacity && item.initialCapacity < otherItem.finalCapacity) ||
        (item.finalCapacity > otherItem.initialCapacity && item.finalCapacity <= otherItem.finalCapacity) ||
        (item.initialCapacity <= otherItem.initialCapacity && item.finalCapacity >= otherItem.finalCapacity)
      );
    });

    if (overlaps) {
      newErrors.costs[index].overlapError = true;
      hasOverlap = true;
      isValid = false;
    }
  });

  if (hasOverlap) {
    errorMessages.add("Há sobreposição de capacidades entre os veículos. Verifique e tente novamente");
  }

  // Verificar valores zerados
  let hasZeroValue = false;
  form.costs.forEach((item, index) => {
    if (item.cost === 0) {
      newErrors.costs[index].cost = true;
      hasZeroValue = true;
      isValid = false;
    }
  });

  if (hasZeroValue) {
    errorMessages.add("O valor não pode ser zero");
  }

  // Verificar leaderCommission
  let hasLeaderCommissionError = false;
  form.costs.forEach((item, index) => {
    if (item.leaderCommission === 0 || item.leaderCommission === null) {
      newErrors.costs[index].leaderCommission = true;
      hasLeaderCommissionError = true;
      isValid = false;
    }
  });

  if (hasLeaderCommissionError) {
    errorMessages.add("O campo comissão do líder não pode ser zero");
  }

  // Exibir todos os erros únicos
  errorMessages.forEach(message => {
    toast.error(message);
  });

  return { isValid, errors: newErrors };
}; 